import { lazy } from 'react';

const DashboardTaskList = lazy(() =>
  import('../pages/dashboard/list')
);

const TicketAdd = lazy(() =>
  import('../pages/dashboard/add')
);

const TaskView = lazy(() =>
  import('../pages/dashboard/TaskView')
);

const TaskEdit = lazy(() =>
  import('../pages/dashboard/TaskEdit')
);

const privateRoutes = [
  { 
    key: 'test1234',
    path: '/',
    component: DashboardTaskList,
    exact: true
  },
  { 
  key: 'test123',
  path: '/dashboard/',
  component: DashboardTaskList,
  exact: true
  },
  {
    key: 'dashboard',
    path: '/dashboard/list',
    component: DashboardTaskList,
    exact: true
  },
  {
    key: 'add-ticket',
    path: '/dashboard/ticket/add/:typeId',
    component: TicketAdd,
    exact: true
  },
  {
    key: 'view-task',
    path: '/dashboard/task/view/:taskId',
    component: TaskView,
    exact: true
  },
  {
    key: 'edit-task',
    path: '/dashboard/task/edit/:taskId',
    component: TaskEdit,
    exact: true
  },
];

export default {
  privateRoutes
};
